// eslint-disable-next-line import/prefer-default-export
export const isMobile = (): boolean => {
  if (/Mobi/.test(navigator.userAgent)) {
    return true
  }
  return false
}
